import React from 'react'
import { SpaceProps, LayoutProps } from 'styled-system'
import { StyledCheckbox, Wrapper, Tick, Label } from './CheckboxStyles'

export interface CheckboxProps extends SpaceProps, LayoutProps {
  checked?: boolean
  name: string
  id: string
  label?: string
  onChange?: React.ChangeEventHandler<HTMLInputElement>
}

export const Checkbox: React.VFC<CheckboxProps> = ({
  name,
  id,
  checked,
  label,
  onChange,
}) => (
  <>
    <Wrapper>
      <StyledCheckbox
        id={id}
        name={name}
        checked={checked}
        type="checkbox"
        onChange={onChange}
      />
      <Tick checked={checked} />
    </Wrapper>
    {label && <Label htmlFor={id}>{label}</Label>}
  </>
)
